import { Flex, Modal, ModalProps } from "antd";
import { FC, useEffect, useState } from "react";
import ContentWrap from "./style";
import { fetchAllQuotationRequests, handleSelect } from "@/apis/requirement";
import { Product } from "@/types/product";
import { QuotationRequest, QuotationRequestSelectedEnum } from "@/types/requirement";
import { useTranslation } from "react-i18next";
import Itemtable from "./Itemtable";
import ProductDesc from "@/components/Desc/ProductDesc";
import { AcceptStateEnum } from "@/types/purchase";
import ExportProgressModal from "@/components/ExportProgressModal";

interface DataType {
  product: Product;
  quotations: Array<QuotationRequest>;
  selectedId?: string;
  disSelect: boolean;
  hasChanged: boolean;
}

interface MultiQuotationOptProps extends ModalProps {
  onClose: () => void;
  onSuccess: () => void;
  requirementId: string;
}

const MultiQuotationOpt: FC<MultiQuotationOptProps> = ({ onClose, onSuccess, requirementId, ...restProps }) => {

  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  // const [quotationsTemp, setQuotationsTemp] = useState<Array<QuotationRequest>>([]);
  const [quotationData, setQuotationData] = useState<Array<DataType>>([]);
  const [showProcess, setShowProcess] = useState<boolean>(false);
  const [process, setProcess] = useState<number>(0);

  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    setLoading(true)
    fetchAllQuotationRequests(requirementId)
      .then(res => {
        // setQuotationsTemp(res?.body || [])

        let productQuoMap: Record<string, QuotationRequest[]> = {};
        let gruopData: Array<DataType> = [];

        res?.body?.forEach(quotation => {
          let productId = quotation.requirementItem?.productId ?? "";
          if (productQuoMap?.[productId]) productQuoMap[productId].push({ ...quotation })
          else productQuoMap[productId] = [{ ...quotation }]
        })
        for (let key in productQuoMap) {
          gruopData.push(
            {
              product: productQuoMap[key][0].requirementItem?.product!,
              quotations: [...productQuoMap[key]],
              selectedId: productQuoMap[key].find(quo => quo.selected === QuotationRequestSelectedEnum.SELECTED)?.id,
              disSelect: !!productQuoMap[key].find(quo => !!quo.purchaseItemId),
              hasChanged: false
            }
          )
        }
        setQuotationData(gruopData)
      })
      .catch(() => {

      })
      .finally(() => setLoading(false))
  }

  const handleChangeSelect = (id: string, productId: string) => {
    setQuotationData(prev => {
      return prev.map(data => ({
        ...data,
        selectedId: data.product.id === productId ? id : data.selectedId,
        hasChanged: data.product.id === productId ? true : data.hasChanged
      }))
    })
  }

  const handleConfirm = async () => {
    const selctedIds = quotationData.filter(record => !!record.selectedId && !record.disSelect && record.hasChanged).map(record => record.selectedId);
    if (selctedIds.length === 0) return onClose();

    setShowProcess(true)
    setProcess(0);
    for (let index = 0; index < selctedIds.length; index++) {
      await handleSelect(selctedIds[index]!)
      setProcess(Math.round(((index + 1) / selctedIds.length) * 100));
    }

    setTimeout(() => {
      setShowProcess(false);
      onClose();
    }, 300)
  };

  return <Modal
    title={t('requirement.batchSelect')}
    loading={loading}
    centered
    width={1000}
    onCancel={onClose}
    onOk={handleConfirm}
    {...restProps}
  >
    <ContentWrap>
      {
        quotationData.map(item => (
          <Flex className="list-item" vertical style={{ width: "100%" }}>
            <ProductDesc product={item.product} />
            <Itemtable
              data={item.quotations}
              selectedId={item.selectedId}
              onSelectChange={handleChangeSelect}
              disabled={item.disSelect}
            />
          </Flex>
        ))
      }
    </ContentWrap>
    <ExportProgressModal visible={showProcess} progress={process} title={t('requirement.batchSelect')} processLabel={t('requirement.progress')} />
  </Modal>
};

export default MultiQuotationOpt;